import React, { useState } from "react";
import "../../components/DashboardModule/NotVerifiedModal.css";
import logostelmart from '../../assets/images/logostelmart.png';
import { RxCross2 } from "react-icons/rx";
import VerifyAccountModal from "../VerifyAccountModal/VerifyAccountModal";
import SidebarTab from '../SidebarTab/SidebarTab';
const VerifyAccount = ({ onClose }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const openModal = (e) => {
        e.stopPropagation();
        console.log("Opening modal... current state:", isModalOpen);
        setIsModalOpen(true);
    };

    const closeModal = (e) => {
        e?.stopPropagation();
        console.log("Closing modal...");
        setIsModalOpen(false);
    };

    return (
        <div className="verification-container">
            <SidebarTab />
            <div className="my-business-details-review">
                <div className="main-wrapper-with-btn">
                <p className="notModal-text font-poppins text-verify">
                No Business Details to show here.
                </p> 
                <p className="notModal-text font-poppins text-verify">
                Please Verify Your Account</p>
                <button
                    className="notModal-button font-poppins"
                    onClick={openModal}
                >
                  VERIFY ACCOUNT
                </button>
                {isModalOpen && <VerifyAccountModal isOpen={isModalOpen} onClose={closeModal} />}
                </div>
            </div>
        </div>
    );
};

export default VerifyAccount;